import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';

export default function DetailView({img, name, price, description }) {
  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  //DetailView details

  return (
    <>
      <div className="w-1/2 mx-auto  py-24">
        <button
          type="button"
          onClick={openModal}
          className={` text-lg text-center w-full mx-auto p-1 font-medium text-white bg-[#fb9815]
            
            rounded-md `}
        >
          Quick View
        </button>
      </div>
      <div className="">
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto lg:pl-8 lg:pr-8 bg-black bg-opacity-75"
          onClose={closeModal}
        >
          <div className="min-h-screen w-full lg:px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full  p-2 lg:p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="mt-2">
                  <div className="w-full  sm:mx-auto max-h-full p-2 lg:p-10 bg-gray-100 rounded-lg">
                   
                    <div className=" items-center justify-center">
                      <div class="rounded-lg lg:flex shadow-xl ">
                        <div class="p-4 lg:w-1/3">
                          <img
                            src={img}
                            alt=""
                            class="h-full w-full rounded-lg object-center object-contain"
                          />
                        </div>
                        <div class="p-2 w-full lg:w-2/3 text-left">
                          <h2 class="text-lg uppercase lg:text-2xl font-bold">{name}</h2>

                          <div class="hidden text-blue-300 text-2xl flex  mx-auto items-center ">
                            <svg
                              class="w-12 h-12 "
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                            </svg>
                            <svg
                              class="w-4 h-4 "
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                            </svg>
                            <svg
                              class="w-4 h-4 "
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                            </svg>
                            <svg
                              class="w-4 h-4 "
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                            </svg>
                            <svg
                              class="w-4 h-4 "
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                            </svg>
                            <i class="text-xs lg:text-sm text-gray-600">
                              {' '}
                              ( 200 )
                            </i>
                          </div>
                          <h3 class="text-lg mt-2 lg:text-xl font-bold text-blue-600">
                            {price} <strike class="text-gray-600">70.00</strike>
                          </h3>
                          <h4 className="text-gray-600 mt-2">{description}</h4>
                          <label className="text-gray-900 mt-2 font-bold text-xl">SIZE</label>
                          <div class="text- w-full  gap-4">
                            <select className="border mb-2 p-2 w-full block ">
                                    <option>Small</option>

                            </select>
                            <label className="text-gray-900 mt-2 font-bold text-xl">COLOR</label>
                            <select className="border mb-2 p-2 w-full block ">
                                    <option>White</option>

                            </select>
                            <label className="text-gray-900 mt-2 font-bold text-xl">QUANTITY</label><br />
                            <button className="rounded text-2xl text-gray-900 bg-white border pt-1 pb-1 pl-2 pr-2">-</button><input type="number" className="p-2 ml-2 mr-2 w-16" /><button className="rounded text-gray-900 font-bold text-xl border pt-1 pb-1 pl-2 pr-2 bg-white ">+</button>
                          <br /><button class=" mt-4 bg-[#fb9815] rounded-lg w-40  border border-gray-100 text-gray-100 hover:bg-gray-600 hover:text-gray-900 p-2">
                            Add To Cart
                          </button>
                          <svg class="ml-2 inline w-8 h-8 text-xl text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg> <span className="text-gray-800 text-lg lg:text-xl">In Stock</span>
                        </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={closeModal}
                  >
                    continue shopping
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
      </div>
    </>
  );
}
